/** @jsxImportSource @emotion/react */

import { useMutation } from '@apollo/client'
import { FC, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { createVideo, createVideoVariables } from '__generatedTypes__/createVideo'
import { updateVideoCategory, updateVideoCategoryVariables } from '__generatedTypes__/updateVideoCategory'
import { CREATE_VIDEO, UPDATE_VIDEO_CATEGORY } from 'queries/video'
import { toast } from 'utils/toast'
import { IResourceData, IVideoCategoryProps } from '../types'
import withVideoCategoryCheck from '../withVideoCategoryCheck'
import * as commonClasses from '../commonStyles'
import VideoResourceForm from './VideoResourceForm'

const VideoResourceCreate: FC<IVideoCategoryProps> = ({ videoCategory, redirectToVideoDashboard }) => {
  const { platform = '' } = useParams()

  const [createVideo] = useMutation<createVideo, createVideoVariables>(CREATE_VIDEO)
  const [updateVideoCategory] = useMutation<updateVideoCategory, updateVideoCategoryVariables>(UPDATE_VIDEO_CATEGORY)

  //TODO to add error handling
  const handleSubmit = useCallback(
    async (fieldsValues: IResourceData) => {
      try {
        const { data } = await createVideo({
          variables: {
            createVideoInput: {
              title: fieldsValues.title,
              resourseURL: fieldsValues.resourseURL,
              order: videoCategory.video.length,
            },
          },
        })
        const videos = videoCategory.video?.map((video) => ({ id: video.id })) || []
        await updateVideoCategory({
          variables: {
            updateVideoCategoryInputFieldName: {
              id: videoCategory.id,
              video: [...videos, { id: data?.createVideo.id || '' }],
            },
          },
        })

        redirectToVideoDashboard()
        toast.success('Video resource created successfully')
      } catch (error) {
        toast.error('Failed to create video resource')
      }
    },
    [platform, videoCategory]
  )

  return (
    <div css={commonClasses.containerPadding}>
      <VideoResourceForm videoCategory={videoCategory} handleSubmit={handleSubmit} />
    </div>
  )
}

export default withVideoCategoryCheck(VideoResourceCreate)
